import { Flag, Shield, UserCheck } from "lucide-react";

import { SessionAnalysis } from "../../../../../types/supabase";

interface RiskMonitorProps {
  analysis: SessionAnalysis;
}

export const RiskMonitor = ({ analysis }: RiskMonitorProps) => {
  const isAlert =
    analysis?.content?.alert &&
    analysis?.content?.alert.toLowerCase() !== "none";
  const color = isAlert ? "red" : "green";
  const content = isAlert ? analysis?.content?.alert : "No alerts, all good!";

  return (
    <section className="rounded-xl bg-white p-6 shadow-sm">
      <h2 className="mb-6 flex items-center text-xl font-semibold">
        <Shield className="mr-2 size-5 text-green-600" />
        Risk & Ethics Monitoring
      </h2>
      <div className="space-y-4">
        {analysis?.content?.stressors && (
          <div className="rounded-lg bg-red-100 p-4">
            <div className="mb-2 flex items-center">
              <Flag className="mr-2 size-4 text-red-600" />
              <h3 className="text-black-900 font-medium">Flagged Keywords</h3>
            </div>
            <p className="text-black-800 text-sm">
              Detected: {analysis?.content?.stressors.join(", ")}
            </p>
          </div>
        )}
        <div className={`bg- p-4${color}-100 rounded-lg`}>
          <div className="mb-2 flex items-center">
            <UserCheck className={`text- size-4${color}-600 mr-2`} />
            <h3 className={`text-black-900 font-medium`}>Alerts</h3>
          </div>
          <p className="text-black-800 text-sm">{content}</p>
        </div>
      </div>
    </section>
  );
};
